module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.3-229.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.3.3.md
// module id = 674
// module chunks = 306